<template>
    <v-main>
        <v-container fluid>
            <v-card elevation="6">
                <v-card-title class="mt-4">
                    <v-btn class="mr-2" fab x-small color="#6c5dd4" dark @click="$router.back()">
                        <v-icon dark> mdi-arrow-left </v-icon> </v-btn>Edit admin
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <span class="text-h6">Basic details</span>
                        </v-col>
                        <v-col xl="4" lg="4" md="4" sm="12">
                            <label for="">Name * </label>
                            <vs-input primary v-model="form.name" placeholder="Enter a name" icon-after block>
                                <template #icon>
                                    <i class='mdi mdi-face-man'></i>
                                </template>
                            </vs-input>
                        </v-col>
                        <v-col xl="4" lg="4" md="4" sm="12" cols="12">
                            <label for="">Mobile no *</label>
                            <vs-input primary v-model="form.phone" placeholder="Enter a mobile number" icon-after block
                                :message-danger="errors.phone">

                                <template #icon>
                                    <i class='mdi mdi-phone'></i>
                                </template>
                            </vs-input>
                        </v-col>
                        <v-col xl="4" lg="4" md="4" sm="12" cols="12">
                            <label for="">Email *</label>
                            <vs-input primary v-model="form.email" placeholder="Enter a email" icon-after block
                                :message-danger="errors.email">

                                <template #icon>
                                    <i class='mdi mdi-email'></i>
                                </template>
                            </vs-input>
                        </v-col>
                        <v-col cols="12">
                            <span class="text-h6">Company</span>
                        </v-col>
                        <v-col xl="4" lg="4" md="4" sm="12" cols="12">
                            <v-autocomplete v-model="form.companies[0].id" :items="Companies" outlined
                                label="Select Company" append-icon="mdi-city"
                                :error-messages="errors.company_id"></v-autocomplete>
                        </v-col>
                        <v-col xl="4" lg="4" md="4" sm="12" cols="12">
                            <v-switch v-model="form.active" inset :label="`Is Active: ${form.active == true ? 'YES' : 'NO'
                        }`"></v-switch>
                        </v-col>

                    </v-row>
                    <v-row>
                        <v-col>
                            <v-divider class="mt-5 mb-5"> </v-divider>
                            <vs-button class="float-right" :loading="isLoading" color="primary" :disabled="isLoading"
                                :dark="isLoading != true" @click="save">
                                Update
                                Admin
                            </vs-button>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-container>
    </v-main>
</template>

<script>
import axios from "axios";
export default {
    name: "UserCreatePage",
    data() {
        return {
            form: {
            },
            Companies: [],
            isLoading: false,
        };
    },
    mounted() {
        this.getMasters();
        this.getData();
    },
    methods: {
        async getMasters() {
            let masters = await axios.get(`users/masters`);
            masters = masters.data
            // companies
            masters.companies.forEach((company) => {
                this.Companies.push({
                    id: company.id,
                    text: company.name,
                    value: company.id,
                })
            });
        },
        async getData() {
            this.isLoading = true;
            let form = await axios.get(`/users/${this.$route.params.adminId}`);
            this.form = form.data.data;
            this.isLoading = false;
        },
        async save() {
            try {
                this.isLoading = true;
                this.form.role_id = 2;
                this.form.company_id = this.form.companies[0] != null ? this.form.companies[0].id : '';
                let admin = await axios.patch(`/users/${this.$route.params.adminId}`, this.form);
                this.admin = admin.data.data;
                this.$router.push('/admins')
                this.isLoading = false;
            } catch (e) {
                this.isLoading = false;
            }
        },
    },
};
</script>